module.exports = __webpack_public_path__ + "media/audio4.2d0bd78e.mp3";